export const createTestId = (baseTestId?: string, testId?: string) => {
  if (baseTestId && testId) {
    return `${baseTestId}.${testId}`;
  }
};
